//@ts-nocheck
import { FC, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import { containsSpecialChars, getCharacterLimitMessage, getSpecialCharacterMessage } from "../../../../../../utils/commonFunctions";
import GroundStationService from "../../../../../../service/GroundStationService";
import { useParams } from "react-router-dom";
import { showToastMessage } from "../../../../../../utils/commonFunctions";

interface CreateGSModalProps {
    close: () => void;
    open: any;
    all_providers: any[];
    provider_details: any;
    loading: any;
    setLoading: (data) => void;
    select_ground_station: (station, provider_name) => void;
}


const CreateGSModal: FC<CreateGSModalProps> = ({ close, open, all_providers, loading, setLoading, provider_details, select_ground_station }) => {

    const params = useParams()
    const { mission_id } = params

    const [defaultProviderList, setDefaultProviderList] = useState<any>([
        {
            value: 'ATLAS',
            label: 'ATLAS'
        },
        {
            value: 'Leaf Space',
            label: 'Leaf Space'
        },
        {
            value: 'Other',
            label: 'Other'
        },
    ])
    const [selectOtherProvider, setSelectOtherProvider] = useState<any>(false)
    const [groundStationDetails, setGroundStationDetails] = useState<any>({
        groundStationName: '',
        properties: {
            country: '',
            location: '',
            latitude: '',
            longitude: '',
            freqbands: [],
            provider: '',
        },
        status: 'Configure',
    })

    const handle_close = () => {
        setGroundStationDetails({
            groundStationName: '',
            properties: {
                country: '',
                location: '',
                latitude: '',
                longitude: '',
                freqbands: [],
                provider: '',
            },
            status: 'Configure',
        })
        setSelectOtherProvider(false)
        close()
    }

    useEffect(() => {
        if (all_providers?.length > 0 && !provider_details) {
            // Start from the current list (clone it so we don’t mutate state directly)
            let updatedArray: Array<{ value: string; label: string }> = [
                ...defaultProviderList,
            ];

            all_providers.forEach((provider) => {
                const new_object = {
                    value: provider.providerName,
                    label: provider.providerName,
                };
                // Filter out any existing entry with the same value
                updatedArray = updatedArray.filter(
                    (item) => item.value !== new_object.value
                );
                // Push the new object
                updatedArray.push(new_object);
            });

            // Finally, ensure “Other” is present once
            updatedArray = updatedArray.filter((item) => item.value !== "Other");
            updatedArray.push({ value: "Other", label: "Other" });

            setDefaultProviderList(updatedArray);
        } else if (provider_details) {
            setDefaultProviderList([
                {
                    value: provider_details.providerName,
                    label: provider_details.providerName,
                },
            ]);
            setGroundStationDetails((prev) => ({
                ...prev,
                properties: {
                    ...prev.properties,
                    provider: provider_details.providerName,
                },
            }));
        }
    }, [all_providers, provider_details]);


    const check_validation = () => {
        if (containsSpecialChars(groundStationDetails?.['groundStationName'])) {
            showToastMessage('error', getSpecialCharacterMessage())
            return false
        }
        else if (groundStationDetails?.['groundStationName'] === '') {
            showToastMessage('error', 'Please enter ground station name')
            return false
        }
        else if (groundStationDetails?.['properties']?.['latitude'] === '') {
            showToastMessage('error', 'Please enter latitude')
            return false
        }
        else if (groundStationDetails?.['properties']?.['longitude'] === '') {
            showToastMessage('error', 'Please enter longitude')
            return false
        }
        else if (selectOtherProvider && groundStationDetails?.['properties']?.['provider'] === '') {
            return false
        }
        else if (groundStationDetails?.['properties']?.['freqbands']?.length === 0) {
            showToastMessage('error', 'Please select atleast one frequency')
            return false
        } else {
            return true
        }
    }

    const fetch_ground_station_location = () => {
        let gs_name = groundStationDetails?.['groundStationName']?.trimEnd()
        let body = {
            ...groundStationDetails,
            groundStationName: gs_name,
            missionId: mission_id,
            properties: {
                ...groundStationDetails?.['properties'],
                provider: groundStationDetails?.['properties']?.['provider']?.trimEnd(),
                location: '',
                country: '',
            },
            "antennaId": ['']
        }
        GroundStationService.createGroundStation(gs_name, body).then((res) => {
            if (res?.data) {
                const station = res?.data
                const provider = res?.data?.['properties']?.['provider']
                let provider_name = (provider && provider !== '') ? provider : 'Standalone'
                select_ground_station(station, provider_name)
            }
        }).catch((err) => {
            console.error(err);
            setLoading(false)
        }).finally(() => {
            handle_close()
            showToastMessage('success', 'Ground Station created successfully')
        })
    }

    const creae_ground_station = () => {
        let validation = check_validation()
        if (validation) {
            setLoading(true)
            fetch_ground_station_location()
        }
    }

    const handleName = (e, entity) => {
        e.preventDefault()
        const isNotValidName = containsSpecialChars(e.target.value)
        if (isNotValidName) {
            showToastMessage('error', getSpecialCharacterMessage())
        } else {
            if (e.target.value.length > 26) {
                showToastMessage('error', getCharacterLimitMessage(26))
            } else {
                if (entity === 'Ground Station') {
                    setGroundStationDetails({
                        ...groundStationDetails,
                        groundStationName: e.target.value.trimStart()
                    })
                } else {
                    setGroundStationDetails({
                        ...groundStationDetails,
                        properties: {
                            ...groundStationDetails?.properties,
                            provider: e.target.value.trimStart()
                        },
                        status: 'Configure'
                    })
                }
            }
        }
    }

    return (
        <div className={`gs_create_modal_container ${open ? 'active' : ''}`}>
            <div className='w-100 px-3 py-2 d-flex align-items-center justify-content-between'>
                <div className='d-flex gap-2 align-items-center'>
                    <img src={require('../../../../../../assets/images/svgs/gs/ground_station.svg').default} width='20px' height='20px' alt='mission' />
                    <span className='fs-16 mt-1'>Add New Ground Station</span>
                </div>
                <button disabled={loading} className='p-0 border-0 bg-transparent' onClick={handle_close}>
                    <i className='fe fe-x fs-20 color-text'></i>
                </button>
            </div>
            <div className={`gs_create_modal_container_body ${loading && 'opacity-50'}`}>
                <div className="d-flex flex-column gap-3">
                    <span className="fs-16 color-atmos-secondary"> Basic Details</span>
                    <div className={`w-100 d-flex align-items-center justify-content-between`}>
                        <span>Name *</span>
                        <Form.Control disabled={loading} type="text" className="w-70" placeholder="Title" value={groundStationDetails?.groundStationName}
                            onChange={(event) => {
                                handleName(event, 'Ground Station');
                            }}
                        />
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-between">
                        <span>Latitude *</span>
                        <Form.Control disabled={loading} type="number" className="w-70" placeholder="In Degrees (°)" value={groundStationDetails?.properties?.latitude}
                            onKeyDown={(e) => {
                                if (e.keyCode === 13 || e.keyCode === 69) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(event: any) => {
                                if (event.target.value.toString().length <= 8) {
                                    if (!isNaN(event.target.value) && Number(event.target.value) <= 90 && Number(event.target.value) >= -90) {
                                        setGroundStationDetails({
                                            ...groundStationDetails,
                                            properties: {
                                                ...groundStationDetails?.properties,
                                                latitude: event.target.value
                                            }
                                        })
                                    } else {
                                        showToastMessage('error', 'Latitude must be between -90 and 90')
                                    }
                                }
                            }}
                        />
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-between">
                        <span>Longitude *</span>
                        <Form.Control disabled={loading} type="number" className="w-70" placeholder="In Degrees (°)" value={groundStationDetails?.properties?.longitude}
                            onKeyDown={(e) => {
                                if (e.keyCode === 13 || e.keyCode === 69) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(event: any) => {
                                event.preventDefault();
                                if (!isNaN(event.target.value) && event.target.value.toString().length <= 8) {
                                    if (Number(event.target.value) <= 180 && Number(event.target.value) >= -180) {
                                        setGroundStationDetails({
                                            ...groundStationDetails,
                                            properties: {
                                                ...groundStationDetails?.properties,
                                                longitude: event.target.value
                                            }
                                        })
                                    } else {
                                        showToastMessage('error', 'Longitude must be between -180 and 180')
                                    }
                                }
                            }}
                        />
                    </div>
                    <div className="w-100 d-flex align-items-center justify-content-between">
                        <span>Provider {selectOtherProvider && '*'}</span>
                        {!selectOtherProvider &&
                            <Select
                                styles={{
                                    control: (provided, state) => ({
                                        ...provided,
                                        borderRadius: "4px",
                                        border: "1px solid rgba(36, 101, 178, 0.6)",
                                        backgroundColor: 'transparent',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        backgroundColor: "#020612",
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        fontSize: "12px !important",
                                        backgroundColor: state.isFocused
                                            ? "#020612"
                                            : "rgba(255, 255, 255, 0.10)",
                                        "&:hover": {
                                            backgroundColor: "#020612",
                                        },
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: "#57585a !important",
                                        fontSize: "12px !important",
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        fontSize: "14px",
                                        color: "#f0f0f0", // Set font size of selected value
                                    }),
                                }}
                                isDisabled={loading}
                                className="w-70"
                                menuPlacement="top"
                                placeholder="Select Provider"
                                value={groundStationDetails?.properties?.provider === '' ? null : { label: groundStationDetails?.properties?.provider, value: groundStationDetails?.properties?.provider }}
                                options={defaultProviderList}
                                onChange={(event) => {
                                    if (event?.label === 'Other') {
                                        setSelectOtherProvider(true)
                                        setGroundStationDetails({
                                            ...groundStationDetails,
                                            properties: {
                                                ...groundStationDetails?.properties,
                                                provider: ''
                                            },
                                        })
                                    } else {
                                        setSelectOtherProvider(false)
                                        setGroundStationDetails({
                                            ...groundStationDetails,
                                            properties: {
                                                ...groundStationDetails?.properties,
                                                provider: event?.label
                                            },
                                            status: 'Configure'
                                        })
                                    }
                                }}
                            />
                        }
                        {selectOtherProvider &&
                            <div className='other_provider_input_container'>
                                <input type="text" placeholder='Enter Provider Name' value={groundStationDetails?.['properties']?.['provider']}
                                    onChange={(e) => {
                                        handleName(e, 'Ground Station Provider');
                                    }} />
                                <button className='other_provider_close_btn' onClick={() => {
                                    setSelectOtherProvider(false)
                                    setGroundStationDetails({
                                        ...groundStationDetails,
                                        properties: {
                                            ...groundStationDetails?.properties,
                                            provider: ''
                                        },
                                    })
                                }}>
                                    <i className='fe fe-x fs-20 color_history' />
                                </button>
                            </div>
                        }
                    </div>
                </div>
                <div className="d-flex flex-column gap-2 mt-2">
                    <span className="fs-16 color-atmos-secondary">Communication Bands *</span>
                    <div className="d-flex flex-wrap gap-3">
                        {["S-band", "X-band", "Ka-band", "UHF"].map((band: any) => (
                            <div className='d-flex gap-1 align-items-center' key={band}>
                                <button disabled={loading} className={`p-0 border-0 bg-transparent`} onClick={() => {
                                    if (groundStationDetails?.properties?.freqbands?.includes(band)) {
                                        setGroundStationDetails({
                                            ...groundStationDetails,
                                            properties: {
                                                ...groundStationDetails?.properties,
                                                freqbands: groundStationDetails?.properties?.freqbands?.filter((item) => item !== band)
                                            }
                                        })
                                    } else {
                                        setGroundStationDetails({
                                            ...groundStationDetails,
                                            properties: {
                                                ...groundStationDetails?.properties,
                                                freqbands: groundStationDetails?.properties?.freqbands?.length > 0 ? [...groundStationDetails?.properties?.freqbands, band] : [band]
                                            }
                                        })
                                    }
                                }}>
                                    {groundStationDetails?.properties?.freqbands?.includes(band) && <img src={require('../../../../../../assets/images/svgs/gs/checked_box.svg').default} width='16px' height='16px' alt='mission' />}
                                    {!groundStationDetails?.properties?.freqbands?.includes(band) && <img src={require('../../../../../../assets/images/svgs/gs/uncheck_box.svg').default} width='16px' height='16px' alt='mission' />}
                                </button>
                                <span className='fs-14'>{band}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="gs_create_modal_container_footer">
                <div className='px-3 py-2 gs_container_footer'>
                    <button disabled={loading} className='btn btn-outline-cancel' onClick={handle_close}>{'Close'}</button>
                    <button disabled={loading} className='btn btn-primary' onClick={creae_ground_station}>Add</button>
                </div>
            </div>
        </div>
    )
}

export default CreateGSModal
